import L from 'leaflet';

import white from '../../../assets/map/marker/rainfall/whiteMarker.png';
import red from '../../../assets/map/marker/rainfall/red.png';
import blue from '../../../assets/map/marker/rainfall/blue.png';
import celadon from '../../../assets/map/marker/rainfall/celadon.png';
import gold from '../../../assets/map/marker/rainfall/gold.png';
import green from '../../../assets/map/marker/rainfall/green.png';
import orange from '../../../assets/map/marker/rainfall/orange.png';
import tawny from '../../../assets/map/marker/rainfall/tawny.png';
import gray from '../../../assets/map/marker/rainfall/gray.png';
import fffff5 from '../../../assets/map/marker/rainfall/fffff5.png';
import ffffcc from '../../../assets/map/marker/rainfall/ffffcc.png';
import ffff99 from '../../../assets/map/marker/rainfall/ffff99.png';
import ffff66 from '../../../assets/map/marker/rainfall/ffff66.png';
import ffff33 from '../../../assets/map/marker/rainfall/ffff33.png';
import ffff0d from '../../../assets/map/marker/rainfall/ffff0d.png';
import ffff00 from '../../../assets/map/marker/rainfall/ffff00.png';
import ccff00 from '../../../assets/map/marker/rainfall/ccff00.png';
import m99ff00 from '../../../assets/map/marker/rainfall/99ff00.png';
import m66ff00 from '../../../assets/map/marker/rainfall/66ff00.png';
import m33ff00 from '../../../assets/map/marker/rainfall/33ff00.png';
import m00ff33 from '../../../assets/map/marker/rainfall/00ff33.png';
import m00ff66 from '../../../assets/map/marker/rainfall/00ff66.png';
import m00ff99 from '../../../assets/map/marker/rainfall/00ff99.png';
import m00ffcc from '../../../assets/map/marker/rainfall/00ffcc.png';
import m00ffff from '../../../assets/map/marker/rainfall/00ffff.png';
import m00ccff from '../../../assets/map/marker/rainfall/00ccff.png';
import m0099ff from '../../../assets/map/marker/rainfall/0099ff.png';
import m0066ff from '../../../assets/map/marker/rainfall/0066ff.png';
import m0033ff from '../../../assets/map/marker/rainfall/0033ff.png';
import m0000ff from '../../../assets/map/marker/rainfall/0000ff.png';
import m4300f8 from '../../../assets/map/marker/rainfall/4300f8.png';
import m6600ff from '../../../assets/map/marker/rainfall/6600ff.png';
import m9900ff from '../../../assets/map/marker/rainfall/9900ff.png';
import cc00ff from '../../../assets/map/marker/rainfall/cc00ff.png';
import ff00ff from '../../../assets/map/marker/rainfall/ff00ff.png';
import ff00cc from '../../../assets/map/marker/rainfall/ff00cc.png';
import ff0099 from '../../../assets/map/marker/rainfall/ff0099.png';
import ff0066 from '../../../assets/map/marker/rainfall/ff0066.png';
import ec0420 from '../../../assets/map/marker/rainfall/ec0420.png';

const iconRainWhite = new L.Icon({
  iconUrl: white,
  iconSize: [10, 10],
});

const iconRainRed = new L.Icon({
  iconUrl: red,
  iconSize: [10, 10],
});

const iconRainBlue = new L.Icon({
  iconUrl: blue,
  iconSize: [10, 10],
});

const iconRainCeladon = new L.Icon({
  iconUrl: celadon,
  iconSize: [10, 10],
});

const iconRainGold = new L.Icon({
  iconUrl: gold,
  iconSize: [10, 10],
});

const iconRainGreen = new L.Icon({
  iconUrl: green,
  iconSize: [10, 10],
});

const iconRainOrange = new L.Icon({
  iconUrl: orange,
  iconSize: [10, 10],
});

const iconRainTawny = new L.Icon({
  iconUrl: tawny,
  iconSize: [10, 10],
});

const iconRainGrey = new L.Icon({
  iconUrl: gray,
  iconSize: [10, 10],
});

const iconfffff5 = new L.Icon({
  iconUrl: fffff5,
  iconSize: [10, 10],
});

const iconffffcc = new L.Icon({
  iconUrl: ffffcc,
  iconSize: [10, 10],
});

const iconffff99 = new L.Icon({
  iconUrl: ffff99,
  iconSize: [10, 10],
});

const iconffff66 = new L.Icon({
  iconUrl: ffff66,
  iconSize: [10, 10],
});

const iconffff33 = new L.Icon({
  iconUrl: ffff33,
  iconSize: [10, 10],
});

const iconffff0d = new L.Icon({
  iconUrl: ffff0d,
  iconSize: [10, 10],
});

const iconffff00 = new L.Icon({
  iconUrl: ffff00,
  iconSize: [10, 10],
});

const iconccff00 = new L.Icon({
  iconUrl: ccff00,
  iconSize: [10, 10],
});

const icon99ff00 = new L.Icon({
  iconUrl: m99ff00,
  iconSize: [10, 10],
});

const icon66ff00 = new L.Icon({
  iconUrl: m66ff00,
  iconSize: [10, 10],
});

const icon33ff00 = new L.Icon({
  iconUrl: m33ff00,
  iconSize: [10, 10],
});

const icon00ff33 = new L.Icon({
  iconUrl: m00ff33,
  iconSize: [10, 10],
});

const icon00ff66 = new L.Icon({
  iconUrl: m00ff66,
  iconSize: [10, 10],
});

const icon00ff99 = new L.Icon({
  iconUrl: m00ff99,
  iconSize: [10, 10],
});

const icon00ffcc = new L.Icon({
  iconUrl: m00ffcc,
  iconSize: [10, 10],
});

const icon00ffff = new L.Icon({
  iconUrl: m00ffff,
  iconSize: [10, 10],
});

const icon00ccff = new L.Icon({
  iconUrl: m00ccff,
  iconSize: [10, 10],
});

const icon0099ff = new L.Icon({
  iconUrl: m0099ff,
  iconSize: [10, 10],
});

const icon0066ff = new L.Icon({
  iconUrl: m0066ff,
  iconSize: [10, 10],
});

const icon0033ff = new L.Icon({
  iconUrl: m0033ff,
  iconSize: [10, 10],
});

const icon0000ff = new L.Icon({
  iconUrl: m0000ff,
  iconSize: [10, 10],
});

const icon4300f8 = new L.Icon({
  iconUrl: m4300f8,
  iconSize: [10, 10],
});

const icon6600ff = new L.Icon({
  iconUrl: m6600ff,
  iconSize: [10, 10],
});

const icon9900ff = new L.Icon({
  iconUrl: m9900ff,
  iconSize: [10, 10],
});

const iconcc00ff = new L.Icon({
  iconUrl: cc00ff,
  iconSize: [10, 10],
});

const iconff00ff = new L.Icon({
  iconUrl: ff00ff,
  iconSize: [10, 10],
});

const iconff00cc = new L.Icon({
  iconUrl: ff00cc,
  iconSize: [10, 10],
});

const iconff0099 = new L.Icon({
  iconUrl: ff0099,
  iconSize: [10, 10],
});

const iconff0066 = new L.Icon({
  iconUrl: ff0066,
  iconSize: [10, 10],
});

const iconec0420 = new L.Icon({
  iconUrl: ec0420,
  iconSize: [10, 10],
});

const iconRain = {
  white: iconRainWhite,
  red: iconRainRed,
  blue: iconRainBlue,
  celadon: iconRainCeladon,
  gold: iconRainGold,
  green: iconRainGreen,
  yellow: iconRainOrange,
  tawny: iconRainTawny,
  grey: iconRainGrey,
  ifffff5: iconfffff5,
  iffffcc: iconffffcc,
  iffff99: iconffff99,
  iffff66: iconffff66,
  iffff33: iconffff33,
  iffff0d: iconffff0d,
  iffff00: iconffff00,
  iccff00: iconccff00,
  i99ff00: icon99ff00,
  i66ff00: icon66ff00,
  i33ff00: icon33ff00,
  i00ff33: icon00ff33,
  i00ff66: icon00ff66,
  i00ff99: icon00ff99,
  i00ffcc: icon00ffcc,
  i00ffff: icon00ffff,
  i00ccff: icon00ccff,
  i0099ff: icon0099ff,
  i0066ff: icon0066ff,
  i0033ff: icon0033ff,
  i0000ff: icon0000ff,
  i4300f8: icon4300f8,
  i6600ff: icon6600ff,
  i9900ff: icon9900ff,
  icc00ff: iconcc00ff,
  iff00ff: iconff00ff,
  iff00cc: iconff00cc,
  iff0099: iconff0099,
  iff0066: iconff0066,
  iec0420: iconec0420,
};

export default iconRain;
